import { useEffect, useState } from "react";
import { fetchExpenses, fetchExpensesByUserId } from "../Api/ViewExpense";
import { Container, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import moment from "moment";
import { useAuth } from "../Context/AuthContext"; // ✅ Import AuthContext

const ViewExpense = () => {
  const [expenses, setExpenses] = useState([]);
  const { user } = useAuth(); // ✅ Get current user details

  useEffect(() => {
    const loadExpenses = async () => {
      try {
        let data;
        console.log(user.roles);
        // ✅ Check user role and call appropriate API
        // if (user?.roles === "Admin") {
        //   data = await fetchExpenses();
        //   console.log("Fetched all expenses (Admin)");
        // } else {
        //   data = await fetchExpensesByUserId(user?.userId);
        //   console.log(`Fetched expenses for user: ${user?.userId}`);
        // }

        if (user?.roles?.includes("Admin")) {
          data = await fetchExpenses(user?.organisationId);
          console.log("Fetched all expenses (Admin)");
        } else {
          data = await fetchExpensesByUserId(user?.userId);
          console.log(`Fetched expenses for user: ${user?.userId}`);
        }

        setExpenses(data.data || []);
      } catch (error) {
        console.error("Error fetching expenses:", error);
        toast.error(`🦄 Error Fetching Expense`);
      }
    };

    if (user) loadExpenses(); // ✅ Only run when user data is loaded
  }, [user]);

  // Function to determine if a file is an image based on extension
  const isImageFile = (filename) => {
    if (!filename) return false;
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
    const ext = filename.substring(filename.lastIndexOf(".")).toLowerCase();
    return imageExtensions.includes(ext);
  };

  // Function to render receipt content appropriately
  const renderReceipt = (receiptUrl) => {
    if (!receiptUrl) return "No receipt";

    if (isImageFile(receiptUrl)) {
      return (
        <a href={receiptUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={receiptUrl}
            alt="Receipt"
            style={{
              maxWidth: "50px",
              maxHeight: "50px",
              cursor: "pointer",
            }}
            title="Click to view full image"
          />
        </a>
      );
    } else {
      return (
        <a href={receiptUrl} target="_blank" rel="noopener noreferrer">
          View Receipt
        </a>
      );
    }
  };

  return (
    <>
      <div className="main-content expand">
        <Container fluid className="list-container">
          <span className="list-title">View Expenses</span>

          {expenses.length > 0 ? (
            <div className="table-wrapper">
              <div className="table-scroll-container">
                <Table bordered hover className="data-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Expense ID</th>
                      <th>Trip ID</th>
                      <th>Expense Type</th>
                      <th>Expense Type 2</th>
                      <th>Merchant</th>
                      <th>Date</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Payment Method</th>
                      <th>Receipt</th>
                      <th>Description</th>
                      <th>Serial No</th>
                      <th>Approval Status</th>
                      <th>Created At</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expenses.map((expense, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{expense.expenseId}</td>
                        <td>{expense.tripId}</td>
                        <td>{expense.expenseType}</td>
                        <td>{expense.expenseType2}</td>
                        <td>{expense.merchantName}</td>
                        <td>
                          {new Date(expense.dateofExpense).toLocaleDateString()}
                        </td>
                        <td>{expense.amountSpent}</td>
                        <td>{expense.currency}</td>
                        <td>{expense.paymentMethod}</td>
                        <td>{renderReceipt(expense.receiptUpload)}</td>
                        <td>{expense.descriptionNotes}</td>
                        <td>{expense.sno}</td>
                        <td>{expense.approvalStatus}</td>
                        <td>
                          {moment(expense.createdAt).format("L")} at{" "}
                          {moment(expense.createdAt).format("LTS")}
                        </td>
                        <td>{expense.createdBy}</td>
                      </tr>
                    ))}
                    <tr
                      style={{ fontWeight: "bold", backgroundColor: "#f8f9fa" }}
                    >
                      <td colSpan={7} style={{ textAlign: "right" }}>
                        Total:
                      </td>
                      <td>
                        {expenses
                          .reduce(
                            (sum, expense) =>
                              sum + (parseFloat(expense.amountSpent) || 0),
                            0
                          )
                          .toFixed(2)}
                      </td>
                      <td colSpan={8}></td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          ) : (
            <p className="no-data">No expenses found.</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewExpense;

// import { useEffect, useState } from "react";
// import { fetchExpenses } from "../Api/ViewExpense";
// import { Container, Table } from "react-bootstrap";
// import { toast } from "react-toastify";
// import moment from "moment";
// // import "../Styling/ViewExpense.css";

// const ViewExpense = () => {
//   const [expenses, setExpenses] = useState([]);

//   useEffect(() => {
//     const loadExpenses = async () => {
//       try {
//         const data = await fetchExpenses();
//         setExpenses(data.data || []);
//       } catch (error) {
//         toast.error(`🦄 Error Fetching Expense`);
//       }
//     };

//     loadExpenses();
//   }, []);

//   // Function to determine if a file is an image based on extension
//   const isImageFile = (filename) => {
//     if (!filename) return false;
//     const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
//     const ext = filename.substring(filename.lastIndexOf(".")).toLowerCase();
//     return imageExtensions.includes(ext);
//   };

//   // Function to render receipt content appropriately
//   const renderReceipt = (receiptUrl) => {
//     if (!receiptUrl) return "No receipt";

//     if (isImageFile(receiptUrl)) {
//       return (
//         <a href={receiptUrl} target="_blank" rel="noopener noreferrer">
//           <img
//             src={receiptUrl}
//             alt="Receipt"
//             style={{ maxWidth: "50px", maxHeight: "50px", cursor: "pointer" }}
//             title="Click to view full image"
//           />
//         </a>
//       );
//     } else {
//       return (
//         <a href={receiptUrl} target="_blank" rel="noopener noreferrer">
//           View Receipt
//         </a>
//       );
//     }
//   };

//   return (
//     <>
//       <div className="main-content expand">
//         <Container fluid className="list-container">
//           <span className="list-title">View Expenses</span>

//           {expenses.length > 0 ? (
//             <div className="table-wrapper">
//               <div className="table-scroll-container">
//                 <Table bordered hover className="data-table">
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                       <th>Expense ID</th>
//                       <th>Trip ID</th>
//                       <th>Expense Type</th>
//                       <th>Merchant</th>
//                       <th>Date</th>
//                       <th>Amount</th>
//                       <th>Currency</th>
//                       <th>Payment Method</th>
//                       <th>Receipt</th>
//                       <th>Description</th>
//                       <th>Serial No</th>
//                       <th>Approval Status</th>
//                       <th>Created At</th>
//                       <th>Created By</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {expenses.map((expense, index) => (
//                       <tr key={index}>
//                         <td>{index + 1}</td>
//                         <td>{expense.expenseId}</td>
//                         <td>{expense.tripId}</td>
//                         <td>{expense.expenseType}</td>
//                         <td>{expense.merchantName}</td>
//                         <td>
//                           {new Date(expense.dateofExpense).toLocaleDateString()}
//                         </td>
//                         <td>{expense.amountSpent}</td>
//                         <td>{expense.currency}</td>
//                         <td>{expense.paymentMethod}</td>
//                         <td>{renderReceipt(expense.receiptUpload)}</td>
//                         <td>{expense.descriptionNotes}</td>
//                         <td>{expense.sno}</td>
//                         <td>{expense.approvalStatus}</td>
//                         <td>
//                           {moment(expense.createdAt).format("L")} at{" "}
//                           {moment(expense.createdAt).format("LTS")}
//                         </td>
//                         <td>{expense.createdBy}</td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             </div>
//           ) : (
//             <p className="no-data">No expenses found.</p>
//           )}
//         </Container>
//       </div>
//     </>
//   );
// };

// export default ViewExpense;
